const variable = 'odisha';

export const all_routes = {
  home: "/index",

  // Blog Routes
  blogGrid: "/blog/blog-grid",
  blogGridSidebarRight: "/blog/blog-grid-sidebar-right",
  blogGridSidebarLeft: "/blog/blog-grid-sidebar-left",
  blogList: "/blog/blog-list",
  blogListSidebarRight: "/blog/blog-list-sidebar-right",
  blogListSidebarLeft: "/blog/blog-list-sidebar-left",
  blogCarousel: "/blog/blog-carousel",
  blogDetails: "/blog/blog-details",
  blogDetailsSidebarRight: "/blog/blog-details-sidebar-right",
  blogDetailsSidebarLeft: "/blog/blog-details-sidebar-left",

  // Pages Routes
  aboutUs: "/pages/about-us",
  comingSoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  events: "/pages/events",
  eventdetails: "/pages/event-details",
  serviceDetail: "/pages/service-detail",
  services: "/pages/services",
  termsCondition: "/pages/terms-condition",
  testimonials: "/pages/testimonials",
  testimonialsCarousel: "/pages/testimonials-carousel",
  maintenance: "/pages/maintenance",
  privacyPolicy: "/pages/privacy-policy",
  pricing: "/pages/pricing",
  ourTeams: "/pages/our-teams",
  myProfile: "/pages/my-profile",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  invoice: "/coaches/invoice",
  lessonOrderConfirm: "/coaches/lesson-order-confirm",
  lessonPayment: "coaches/lesson-payment",
  lessonPersonalinfo: "coaches/lesson-personalinfo",
  userWallet: "/user/user-wallet",

  // Coaches Routes
  bookingCancelled: "/coaches/booking-cancelled",
  bookingCompleted: "/coaches/booking-completed",
  allCourt: "/coaches/all-court",
  appointmentDetails: "/coaches/appointment-details",
  addCourt: "/coaches/add-court",
  activeCourt: "/coaches/active-court",
  inactiveCourt: "/coaches/inactive-court",
  coachDetail: "/coaches/coach-detail",
  coachDetails: "/coaches/coach-details",
  coachEarning: "/coaches/coach-earning",
  coachesGrid: "/coaches/coaches-grid",
  coachesGridSidebar: "/coaches/coaches-sidebar-grid",
  coachesList: "/coaches/coaches-list",
  coachesListSidebar: "/coaches/coaches-sidebar-list",
  coachesMap: "/coaches/coaches-map",
  coachRequest: "/coaches/coach-request",
  coachWallet: "/coaches/coach-wallet",
  coachTimeDate: "/coaches/coach-timedate",
  coachProfile: "/coaches/coach-profile",
  coachPersonalInfo: "/coaches/coach-personalinfo",
  coachPayment: "/coaches/coach-payment",
  coachOrederConfirm: "/coaches/coach-order-confirm",
  coachesMapSidebar: "/coaches/coaches-map-sidebar",
  earningCoaching: "/coaches/earning-coaching",
  cagecheckout: "/coaches/cage-checkout",
  cagedetails: "/coaches/cage-details",
  cageordeconfirm: "/coaches/cage-order-confirm",
  cagepersonalinfo: "/coaches/cage-personalinfo",
  lessonTimeDate: "/coaches/lesson-timedate",
  lessonType: "/coaches/lesson-type",
  settingLesson: "/coaches/setting-lesson",
  settingPassword: "/coaches/setting-password",
  settingAvalibilty: "/coaches/setting-availability",
  profileOtherSetting: "/coaches/profile-othersetting",
  coachDashboard: "coaches/coach-dashboard",
  coachBooking: "/coaches/coach-booking",
  coachChat: "/coaches/coach-chat",
  venueDetails: "/coaches/venue-details",

  // User Routes
  userComplete: "/user/user-complete",
  userDashboardProfiles: "/user/user-dashboard-profiles",
  userDashboard: "/user/user-dashboard",
  userInvoice: "/user/user-invoice",
  userBookings: "/user/user-bookings",
  userChat: "/user/user-chat",
  userCoaches: "/user/user-coaches",
  userProfile: "/user/user-profile",
  userSettingPassword: "/user/user-setting-password",
  userProfileOtherSetting: "/user/user-profile-othersetting",
  userCancelled: "/user/user-cancelled",
  userOngoing: "/user/user-ongoing",

  // Listing Routes
  listingGridSidebar: "/listing/listing-grid-sidebar",
  listingGrid: "/listing/listing-grid",
  listingListSidebar: "/listing/listing-list-sidebar",
  listingList: "/listing/listing-list",
  listingMapSidebar: "/listing/listing-map-sidebar",
  listingMap: "/listing/listing-map",

  // Auth Routes
  register: "/auth/register",
  login: "/auth/login",
  changePassword: "/auth/change-password",
  forgotPasssword: "/auth/forgot-password",

  // added screens

  dashboard: "/"+variable+"/dashboard",

  tenviclogin: "/tenvic/login",
  tenvicForgotPassword: "/tenvic/forgotpassword",
  tenvicUsers: "/tenvic/users",
  tenvicRoles: "/tenvic/role",
  tenvicPermissions: "/tenvic/permission",
  tenvicRolePermissions: "/tenvic/rolepermission",
  tenvicMenus: "/tenvic/menu",
  tenvicSubMenus: "/tenvic/submenu",
  tenvicMenuRole: "/tenvic/menurole",
  tenvicProfile: "/tenvic/profile",
  tenvicPasswordReset: "/tenvic/passwordreset/:token",
  tenvicUserRBAC: "/tenvic/userrbac",
  tenvicClients: "/tenvic/clientinfo",


  manipurlogin: "/"+variable+"/login",
  manipurForgotPassword: "/"+variable+"/forgotpassword",
  manipurUsers: "/"+variable+"/users",
  manipurRoles: "/"+variable+"/role",
  manipurAccountType: "/"+variable+"/accounttype",
  manipurPermissions: "/"+variable+"/permission",
  manipurRolePermissions: "/"+variable+"/rolepermission",
  manipurMenus: "/"+variable+"/menu",
  manipurSubMenus: "/"+variable+"/submenu",
  manipurChildSubMenus: "/"+variable+"/subsubmenu",
  manipurProfile: "/"+variable+"/profile",
  manipurPasswordReset: "/"+variable+"/passwordreset/:token",
  manipurUserRBAC: "/"+variable+"/userrbac",
  manipurSports: "/"+variable+"/sports",
  manipurSportsCategories: "/"+variable+"/sportscategories",
  manipurTalentScout: "/"+variable+"/talentscout",
  manipurTalentScoutCriteria: "/"+variable+"/talentscoutcriteria",
  manipurGeography: "/"+variable+"/geography",
  manipurBatch: "/"+variable+"/batches",
  manipurBatchAthlete: "/"+variable+"/batchathlete",
  manipurTlntSctAthlt: "/"+variable+"/approveathlete",
  manipurSchedule: "/"+variable+"/testschedule",
  manipurAssessment: "/"+variable+"/assessment",
  manipurCompetitionType: "/"+variable+"/competitiontype",
  manipurCompetitionSports: "/"+variable+"/compsport",
  manipurCompetitionSportType: "/"+variable+"/sporttype",
  manipurCompetition: "/"+variable+"/competitions",
  manipurCompetitionPerformance: "/"+variable+"/compperformance",
  manipurCompetitionSettings:"/"+variable+"/eventsetting",
  manipurSportsList: "/"+variable+"/compsportList",
  manipurAllAthletes: "/"+variable+"/athlete",
  manipurCenterAthletes: "/"+variable+"/centerathletes",
  manipurHPCAthletes: "/"+variable+"/hpcathletes",
  manipurProgramLevel: "/"+variable+"/program",
  manipurSkills: "/"+variable+"/skills",
  manipurScheduleType: "/"+variable+"/scheduletype",
  manipurGradeType:"/"+variable+"/gradetype",
  manipurAssessmentType:"/"+variable+"/assessmenttype",
  manipurAttendanceType:"/"+variable+"/attendancetype",
  manipurGender:"/"+variable+"/gender",
  manipurLevel:"/"+variable+"/level",
  manipurCountry:"/"+variable+"/countries",
  manipurJoint:"/"+variable+"/joints",
  manipuMovement:"/"+variable+"/movements",

  manipurCenterBatch: "/"+variable+"/centerbatch",
  manipurCenterBatchAthlete: "/"+variable+"/centerathlete",
  manipurCenterSchedule: "/"+variable+"/centerschedule",
  manipurCenterAttendance: "/"+variable+"/centerattendance",
  manipurCenterAssessment: "/"+variable+"/centerassessment",
  manipurCenterAthleteApprove: "/"+variable+"/approvecenterathlete",

  manipurHPCAthlete: "/"+variable+"/athletesbyhpc",

  manipurHPCBatch: "/"+variable+"/hpcbatch",
  manipurHPCBatchAthlete: "/"+variable+"/hpcbatchathlete",
  manipurHPCSchedule: "/"+variable+"/hpcschedule",
  manipurHPCAttendance: "/"+variable+"/hpcattendance",
  manipurHPCAssessment: "/"+variable+"/hpcassessment",

  manipurMetricScale:"/"+variable+"/metricScale",
  manipurAthleteMetrics: "/"+variable+"/metricanalysis",

  manipurAcsiAnswers: "/"+variable+"/acsianswers",
  manipurAcsiQuestions: "/"+variable+"/acsiquestions",
  manipurAcsiScoringParameters:"/"+variable+"/acsiscoringparameters",
  manipurPpiAnswers: "/"+variable+"/ppianswers",
  manipurPpiQuestions: "/"+variable+"/ppiquestions",
  manipurPpiScoringParameters:"/"+variable+"/ppiscoringparameters",

  manipurCompetitionsReport: "/"+variable+"/competitionreport",
  manipurCompetitionPerformanceReport: "/"+variable+"/compperformancereport",
  manipurAthleteReport: "/"+variable+"/athletereport",
  manipurScheduleReport: "/"+variable+"/schedulereport",
  manipurTestResultsReport: "/"+variable+"/assessmentreport",

  manipurInjury: "/"+variable+"/injury",
  manipurInjuryAssessment: "/"+variable+"/injuryassessment",
  manipurInjuryDiagnosis:"/"+variable+"/diagnosis",
  manipurInjuryTreatment:"/"+variable+"/treatmentplan",
  manipurScreening:"/"+variable+"/screening",

  manipurBldGrp:"/"+variable+"/bloodgroup",
  manipurAlrgyTyp:"/"+variable+"/allergytype",
  manipurMedCtgry:"/"+variable+"/medicationcategory",
  manipurAlcUse:"/"+variable+"/alcoholusage",
  manipurTbcoUse:"/"+variable+"/tobaccousage",
  manipurInjTyp:""+variable+"/injurytype",
  manipurRgnAfctd:"/"+variable+"/regionaffected",
  manipurDiagType:"/"+variable+"/diagnosistype",
  manipurInjSvrty:"/"+variable+"/injuryseverity",
  manipurInjMech:"/"+variable+"/mechanisminjury",
  manipurInjMgmt:"/"+variable+"/injurymanagementapproach",
  manipurTimeLost:"/"+variable+"/timelostfromtraining",
  manipurSurgCtgry:"/"+variable+"/surgerycategory",
  manipurBdyRgn:"/"+variable+"/bodyregion",
  manipurRehabDur:"/"+variable+"/rehabilitationduration",
  manipurPhysioType:"/"+variable+"/physiologicaltype",
  manipurScrnTstTyp:"/"+variable+"/screeningtesttype",
  manipurSympTyp:"/"+variable+"/symptomtype",
  manipurPainLocTyp:"/"+variable+"/painlocationtype",
  manipurFuncLmt:"/"+variable+"/functionallimitationstype",
  manipurInjTreatTyp:"/"+variable+"/injurytreatmenttype",
  manipurCncsnSymp:"/"+variable+"/concussionspecificsymptom",
  manipurOnst:"/"+variable+"/onset",
  manipurPrfrmTst:"/"+variable+"/performancetest",
  manipurAsgnCntr:"/"+variable+"/assigncenter",
  manipurAsgnHPC:"/"+variable+"/assignhpc",
  manipurOverAllAssessment:"/"+variable+"/detailedassessment",
  manipurPsychology:"/"+variable+"/psychology",
  manipurPsychologyAcsi:"/"+variable+"/acsi",
  manipurExternalSports:"/"+variable+"/extsport",
  manipurExtCompRsltFrmt:"/"+variable+"/extresultformat",
  manipurExtCompCtgry:"/"+variable+"/extcategory",
  manipurLevels:"/"+variable+"/extgeography",
  manipurExtComp:"/"+variable+"/extcompetition",
  manipurExtCompSettings:"/"+variable+"/exteventsetting",
  manipurRbacSettings:"/"+variable+"/rbacsetting",
  manipurTalentScoutingSettings:"/"+variable+"/talentscoutingsetting",
  manipurCompSettings:"/"+variable+"/competitionsetting",
  manipurExternalCompSettings:"/"+variable+"/externalcompsetting",
  manipurCenterSettings:"/"+variable+"/centersetting",
  manipurGeneralSettings:"/"+variable+"/generalsetting",
  manipurInjurySettings:"/"+variable+"/injurysetting",
  manipurPsychologicalPPISettings:"/"+variable+"/psychologicalppisetting",
  manipurPsychologicalAcsiSettings:"/"+variable+"/psychologicalacsisetting",

  manipurTrialBatch:"/"+variable+"/batchhpc",

  manipurAthletes: "/athleteregister",
  manipurAthletesRegs: "/register",

  athleteLogin: "/athlete/login",
  athleteDashboard: "/athlete/dashboard",
  athleteMetrics: "/athlete/metricanalysis",
  athleteProfile: "/athlete/profile",

  athleteInjury: "/athlete/injury",
  athleteInjuryAssessment: "/athlete/injuryassessment",
  athleteInjuryDiagnosis:"/athlete/diagnosis",
  athleteInjuryTreatment:"/athlete/treatmentplan",
  athleteScreening:"/athlete/screening",

  athleteBatch: "athlete/batches",
  athleteBatchAthlete: "athlete/batchathlete",
  athleteSchedule: "athlete/testschedule",
  athleteAssessment: "athlete/assessment",
  athleteCenterBatch: "/athlete/centerbatch",
  athleteCenterBatchAthlete: "/athlete/centerathlete",
  athleteCenterSchedule: "/athlete/centerschedule",
  athleteCenterAttendance: "/athlete/centerattendance",
  athleteCenterAssessment: "/athlete/centerassessment",
  athleteHPCBatch: "/athlete/hpcbatch",
  athleteHPCBatchAthlete: "/athlete/hpcbatchathlete",
  athleteHPCSchedule: "/athlete/hpcschedule",
  athleteHPCAttendance: "/athlete/hpcattendance",
  athleteHPCAssessment: "/athlete/hpcassessment",
  athleteCompetitionPerformance: "/athlete/compperformance",
  athleteExternalCompetitions: "/athlete/extcompetition",

  //contact-us
  contactUs: "/contact-us",
};
